// Marca de Veta Desk: el logo de Veta (familia Veta) + "desk" en League Spartan, minúscula y negrita.
// tone="light" va sobre el encabezado negro (letras de VETA en blanco); "dark" sobre fondo claro.
// "desk" se apoya en la misma línea base que VETA (70 % de la altura del logo).
// product: el mismo logo sirve para toda la familia Veta (desk, horas, change).
export function Wordmark({ tone = 'light', size = 'md', product = 'desk' }: { tone?: 'light' | 'dark'; size?: 'md' | 'lg'; product?: 'desk' | 'horas' | 'change' }) {
  const lg = size === 'lg';
  return (
    <span className="inline-flex items-end" aria-label={`Veta ${product}`} role="img">
      <img src={tone === 'light' ? '/logo-veta-white.svg' : '/logo-veta.svg'} alt="" className={`${lg ? 'h-14' : 'h-10'} w-auto`} />
      <span className={`font-brand font-bold lowercase leading-none tracking-tight ${lg ? 'ml-2 mb-[10px] text-[34px]' : 'ml-1.5 mb-[7px] text-[24px]'} ${tone === 'light' ? 'text-white' : 'text-ink'}`}>
        {product}
      </span>
    </span>
  );
}
